<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('adicionar-transportadora') }}
                            <a class="pl-1" v-if="hide.hideInfo" @click="infoIsHidden()">
                                <b-icon
                                    v-if="!hide.infoIsHidden"
                                    icon="eye-off-outline"
                                    type="is-danger"
                                />
                                <b-icon
                                    v-if="hide.infoIsHidden"
                                    icon="eye-outline"
                                    type="is-success"
                                />
                            </a>
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        isVenda ? $t('vendas') : $t('agro')
                                    }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: `${abrev}-transportadora` })">{{
                                        $t('transportadoras')
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id ? $route.params.id : $t('novo')
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button class="delete-btn" type="button" tag="button" @click="fecharModal">
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="
                                (!usuarioIntegracao && !isUpdate && permissao.create) ||
                                (!usuarioIntegracao && isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="generateId(18)"
                                ref="idErpInput"
                                v-model="transportadora.idtransportadoraerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                :invalid="!transportadora.idtransportadoraerp"
                                tooltipLabel="cod-ref"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-6">
                            <v-input
                                :id="generateId(1)"
                                ref="nomeInput"
                                v-model="transportadora.nome"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="nome"
                                msg="msg-campo-obrigatorio"
                                :invalid="!transportadora.nome"
                                uppercase
                                required
                                tooltipLabel="nome-transportadora"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-4" :class="{ loading: isSearchingCNPJ }">
                            <v-input
                                :id="generateId(2)"
                                :hideInfo="hide.hideInfo"
                                :infoIsHidden="hide.infoIsHidden"
                                v-model="transportadora.cnpj"
                                placeholder="placeholder-preencha"
                                :title="'cnpj'"
                                :msg="invalidCNPJMsg"
                                :invalid="invalidCNPJ"
                                :onBlurFunction="validateCNPJInner"
                                ref="cnpjInput"
                                v-mask="['##.###.###/####-##']"
                                icon="magnify"
                                @input-action="getDadosCliente"
                                required
                                tooltipLabel="cnpj-transportadora"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-2">
                            <v-input
                                :id="generateId(3)"
                                :hideInfo="hide.hideInfo"
                                :infoIsHidden="hide.infoIsHidden"
                                v-model="transportadora.cep"
                                title="cep"
                                placeholder="placeholder-preencha"
                                :msg="invalidCEPMsg"
                                :invalid="invalidCEP"
                                :onBlurFunction="validateCEPInner"
                                ref="cepInput"
                                v-mask="['##.###-###']"
                                tooltipLabel="cep-transportadora"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-5">
                            <v-input
                                :id="generateId(4)"
                                v-model="transportadora.endereco"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="endereco"
                                ref="enderecoInput"
                                tooltipLabel="endereco-transportadora"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-5">
                            <v-input
                                :id="generateId(5)"
                                v-model="transportadora.bairro"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="bairro"
                                ref="bairroInput"
                                tooltipLabel="bairro-transportadora"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-5">
                            <v-input-tel
                                :id="generateId(6)"
                                ref="telefoneInput"
                                :hideInfo="hide.hideInfo"
                                :infoIsHidden="hide.infoIsHidden"
                                v-model="transportadora.telefone"
                                title="telefone"
                                :edit="checkEditTel(transportadora.telefone)"
                                :msg="invalidTelefoneMsg"
                                :invalid="invalidTelefone"
                                :onBlurFunction="validateTelefone"
                                tooltipLabel="telefone-transportadora"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-7">
                            <v-input
                                :id="generateId(7)"
                                ref="contatoInput"
                                v-model="transportadora.contato"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="contato"
                                uppercase
                                tooltipLabel="contato-transportadora"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-10">
                            <v-input
                                :id="generateId(8)"
                                ref="obsInput"
                                v-model="transportadora.obs"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="obs"
                                uppercase
                                tooltipLabel="observacao-transportadora"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-2">
                            <vss-select
                                title="situacao"
                                :id="generateId(9)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="transportadora.id == null || cantEdit"
                                tooltipLabel="situacao-transportadora"
                                tooltipPosition="is-left"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AssClienteTransportadoraService from '@/services/vendas/cliente/abas/AssClienteTransportadoraService';
import TransportadoraService from '@/services/vendas/TransportadoraService';
import TransportadoraValidation from '@/services/validations/vendas/TransportadoraValidation';
import Message from '@/models/Message';
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';

export default {
    components: {
        HideInfo,
    },
    data() {
        return {
            assClienteTransportadoraIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSCLIENTETRANSPORTADORA'
            ),
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'TRANSPORTADORA'
            ),
            service: new TransportadoraService(this.$http, this.$router),
            serviceAss: new AssClienteTransportadoraService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            validation: new TransportadoraValidation(this.$root.msgs),
            transportadora: {
                id: null,
                idtransportadoraerp: null,
                cnpj: null,
                nome: null,
                endereco: null,
                bairro: null,
                cep: null,
                contato: null,
                telefone: null,
                obs: null,
                situacao: null,
            },
            isUpdate: false,
            isSearchingCNPJ: false,
            invalidCNPJ: true,
            invalidCNPJMsg: 'msg-campo-obrigatorio',
            invalidCEP: true,
            invalidCEPMsg: 'msg-campo-obrigatorio',
            invalidTelefone: false,
            invalidTelefoneMsg: 'msg-campo-obrigatorio',
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },
            isChanged: false,
            isLoadingEdit: false,

            //permissoes relativas à exibição dos botões
            permissao: false,
            permissaoVincular: false,
            cantEdit: false,

            // @86308 - Rota dinâmica abreviando o contexto
            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.isChanged = false;
        if (this.$route.params.id) this.isUpdate = true;

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess('vendas', 'clientes', 'ven-transportadora');
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess('agro', 'clientes', 'agro-transportadora');
        }

        this.permissaoVincular = this.permissao.create && !this.assClienteTransportadoraIntegracao;
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'transportadora' },
            });
        } else {
            if (this.isUpdate) {
                this.cantEdit = this.usuarioIntegracao || !this.permissao.update;
                this.carregarDados();
            }
        }
        this.isLoadingEdit = true;
    },
    // @85242
    watch: {
        transportadora: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.isChanged = true;
                } else if (!this.isUpdate) {
                    this.isLoadingEdit = false;
                }
            },
        },
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', { infoIsHidden: !this.hide.infoIsHidden });
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service
                .find(this.$route.params.id)
                .then((value) => {
                    this.transportadora = value.content;
                    this.situacao = this.situacoes[this.transportadora.situacao];
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.validateCEPInner();
                    this.validateCNPJInner();
                    this.isChanged = false;
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                });
        },
        validateCNPJInner() {
            if (!this.transportadora.cnpj) {
                this.invalidCNPJ = true;
                this.invalidCNPJMsg = 'msg-campo-obrigatorio';
            } else if (this.transportadora.cnpj && !this.validateCnpj(this.transportadora.cnpj)) {
                this.invalidCNPJ = true;
                this.invalidCNPJMsg = 'msg-campo-invalido';
            } else {
                this.invalidCNPJ = false;
            }
        },
        validateCEPInner() {
            if (this.transportadora.cep && !this.validateCEP(this.transportadora.cep)) {
                this.invalidCEP = true;
                this.invalidCEPMsg = 'msg-campo-invalido';
            } else {
                this.invalidCEP = false;
            }
        },
        save() {
            this.isLoading = true;
            this.isLoadingEdit = true;

            if (this.validation.validate(this.transportadora, this.$refs)) {
                let transportadoraTemp = Object.assign({}, this.transportadora);
                transportadoraTemp = this.mapTosave(transportadoraTemp);
                transportadoraTemp.situacao = this.situacao.id;
                transportadoraTemp.cnpj = this.transportadora.cnpj;
                this.invalidIcon = false;
                this.isSaving = true;
                this.service
                    .save(transportadoraTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = 'msg-save-transportadora';
                            if (this.transportadora.idtransportadora != null) {
                                msg = 'msg-edit-transportadora';
                            }
                            this.isChanged = false;
                            this.msgs.push(new Message('success', msg, true));
                            // @85242
                            if (
                                this.permissaoVincular &&
                                !this.isUpdate &&
                                this.$route.query.tela == 'cliente-transportadora'
                            ) {
                                this.promptConfirmaVinculo(value.content);
                            } else {
                                this.redirectToPage();
                            }
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        if (e.body.status == 409) {
                            this.msgs.push(
                                new Message('alert', 'msg-existe-cnpj-transportadora', true)
                            );
                        } else {
                            let message = e.body.message;
                            if (message && this.$te(message)) {
                                if (message == 'msg-codigo-duplicado-n') {
                                    this.msgs.push(
                                        new Message(
                                            'alert',
                                            this.$t(message, { n: transportadoraTemp.idtransportadoraerp }),
                                            true,
                                            false
                                        )
                                    );
                                } else {
                                    this.msgs.push(new Message('alert', message, true));
                                }
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                        this.isLoadingEdit = false;
                    });
            } else {
                this.validateCNPJInner();
                this.validateCEPInner();
                this.validateTelefone();
                this.$root.showMessage('alert', 'msg-campos-obrigatorios', true);
                this.isLoading = false;
                this.isLoadingEdit = false;
            }
        },
        fecharModal() {
            // @85242 - Confirmação ao fechar adicionada no modal de transportadora
            if (this.isChanged) {
                this.$root.confirm({
                    message: this.$t('msg-tem-certeza-alteracoes'),
                    onConfirm: (_) => {
                        this.isChanged = false;
                        this.redirectToPage();
                    },
                });
            } else {
                this.redirectToPage();
            }
        },
        redirectToPage() {
            let tempTela = null;
            let tempAba = null;
            // @70955 - voltando para tela de clientes - aba transportadora
            if (this.$route.query.tela == 'cliente-transportadora') {
                tempTela = `${this.abrev}-cliente-dados-cadastrais-edit`;
                setTimeout(
                    () => {
                        this.$router.push({
                            name: tempTela,
                            params: { id: this.$route.query['id'] },
                            query: {
                                dadoscadastrais: this.$route.query.dadoscadastrais,
                                politicacomercial: this.$route.query.politicacomercial,
                                analisecomercial: this.$route.query.analisecomercial,
                            },
                        });
                    },
                    tempAba != null ? 0 : 1000
                );
            } else {
                tempTela = `${this.abrev}-transportadora`;
                setTimeout(
                    () => {
                        this.$router.push({
                            name: tempTela,
                            params: { id: this.$route.query['id'], name: this.$route.query.name },
                            query: { abaSelecionada: tempAba },
                        });
                    },
                    tempAba != null ? 0 : 1000
                );
            }
        },

        // @85242
        promptConfirmaVinculo(vinculo) {
            this.$root.confirm({
                message: this.$t('deseja-realizar-vinculo'),
                onConfirm: (_) => {
                    this.realizarVinculo(vinculo);
                },
                onCancel: (_) => {
                    this.redirectToPage();
                },
            });
        },
        // @85242
        realizarVinculo(vinculo) {
            this.isLoading = true;
            this.isLoadingEdit = true;
            let clienteTransportadoraTemp = {
                transportadora: this.transportadora,
                idtransportadora: vinculo.idtransportadora,
                idcliente: this.$route.query['id'],
            };

            this.saveAss(clienteTransportadoraTemp)
                .then((value) => {
                    if (value.message == null) {
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                        this.redirectToPage();
                    } else {
                        if (this.$t(value.message)) {
                            this.msgs.push(new Message('alert', value.message, true));
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message('alert', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                });
        },
        saveAss(clienteTransportadora) {
            if (this.isVenda) return this.serviceAss.saveAssVendas(clienteTransportadora);
            else return this.serviceAss.saveAssAgro(clienteTransportadora);
        },
        getDadosCliente() {
            let hasError = false;
            if (this.invalidCNPJ) {
                this.validation.showMessage(
                    new Message('error', 'msg-erro-pesquisa-cnpj-invalido', true)
                );
                hasError = true;
            }
            if (hasError) return;

            let cnpj = this.transportadora.cnpj;
            this.isSearchingCNPJ = true;
            this.service
                .getInfoByCNPJ(null, cnpj)
                .then((res) => {
                    if (res.status != 200) {
                        if (res.status == 404) {
                            console.error(`CNPJ ${cnpj} não existe.`);
                            this.msgs.push(new Message('error', 'msg-erro-cnpj-inexistente', true));
                        } else {
                            console.error(`Retorno: ${res.status}`);
                            this.msgs.push(new Message('error', 'msg-erro-pesquisa-cnpj', true));
                        }
                    } else {
                        let hasInfo = false;
                        let r = JSON.parse(res.content);
                        if (typeof r == 'object') {
                            r.forEach((e) => {
                                if (e.situacao == '1') {
                                    hasInfo = true;
                                    this.transportadora.nome = e.nome;
                                    this.transportadora.endereco = e.logradouro + ', ' + e.numero;
                                    this.transportadora.cep = e.cep;
                                    this.transportadora.bairro = e.bairro;
                                }
                            });
                        }
                        if (!hasInfo && r.length > 0) {
                            this.transportadora.nome = r[r.length - 1].nome;
                            this.transportadora.endereco =
                                r[r.length - 1].logradouro + ', ' + r[r.length - 1].numero;
                            this.transportadora.cep = r[r.length - 1].cep;
                            this.transportadora.bairro = r[r.length - 1].bairro;
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-pesquisa-cnpj', true));
                })
                .finally((_) => {
                    this.isSearchingCNPJ = false;
                });
        },
        checkEditTel(val) {
            return this.$route.params.id && !this.isNull(val);
        },
        validateTelefone() {
            if (this.isNull(this.transportadora.telefone)) {
                this.invalidTelefone = false;
            } else if (
                this.transportadora.telefone &&
                !this.validatePhone(this.transportadora.telefone)
            ) {
                this.invalidTelefone = true;
                this.invalidTelefoneMsg = 'msg-campo-invalido';
            } else {
                this.invalidTelefone = false;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
